export const EDIT_PATIENT_LABELS = {
  SAVE_CHANGES: "Guardar cambios",
  CANCEL: "Cancelar"
};

export const EMIT_ACTIONS = {
  CLOSE_MODAL: "closeModal"
};
